/*!

  =========================================================
  * Vue Paper Dashboard 2 PRO - v2.4.1
  =========================================================

  * Product Page: https://www.creative-tim.com/product/vue-paper-dashboard-2-pro
  * Available with purchase of license from https://www.creative-tim.com/product/vue-paper-dashboard-2-pro
  * Copyright 2022 Creative Tim (https://www.creative-tim.com)
  * License Creative Tim (https://www.creative-tim.com/license)

  =========================================================

*/
// require('dotenv').config({ path: '/.env' });
import dotenv from 'dotenv'
import Vue from "vue";
import "./pollyfills";
import VueRouter from "vue-router";
import VueNotify from "vue-notifyjs";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import App from "./App.vue";
import store from './store'
// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/UIComponents/SidebarPlugin";
import initProgress from "./progressbar";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom"

// router setup
import routes from "./routes/routes";

// dotenv.config({path: 'E:\GitHub\NodeJS-CentralGym-Dashboard\src\.env'}); // PC personal
dotenv.config({ path: 'C:\NodeJS-CentralGym-Dashboard\src\.env' }); // PC Oficina
// console.log("process.env******************")
// console.log(process.env)
// library imports

const appVersion = process.env.APP_VERSION || '1.0.0';


import "./assets/sass/paper-dashboard.scss";
import 'animate.css/animate.min.css';
import "./assets/sass/demo.scss";
import { axiosLogin, MasterControlAPP, MasterControlAPI, CentralGymOPS_API, CentralGymOPS_API_Public, DownLoadsMasterControl, Operations, Env, ToDesa, XLSXTemplateDownload, UpdatesCenter } from './axiosService'
import swal from "sweetalert2";
import moment from 'moment'
import PerfectScrollbar from 'perfect-scrollbar';
import html2pdf from 'html2pdf.js';
//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap'

import sidebarLinks from "./sidebarLinks";
import "./registerServiceWorker";
// plugin setup
Vue.prototype.$axiosLogin = axiosLogin;
Vue.prototype.$MasterControlAPP = MasterControlAPP;
Vue.prototype.$MasterControlAPI = MasterControlAPI;
Vue.prototype.$CentralGymOPS_API = CentralGymOPS_API;
Vue.prototype.$CentralGymOPS_API_Public = CentralGymOPS_API_Public;
Vue.prototype.$XLSXTemplateDownload = XLSXTemplateDownload;
Vue.prototype.$DownLoadsMasterControl = DownLoadsMasterControl;
Vue.prototype.$UpdatesCenter = UpdatesCenter;

Vue.prototype.$Operations = Operations;
Vue.prototype.$Env = Env;
Vue.prototype.$moment = moment;
Vue.prototype.$html2pdf = html2pdf;
Vue.prototype.$ToDesa = ToDesa;
Vue.prototype.$ChartsSDK = ChartsEmbedSDK;
Vue.prototype.$swal = swal;
Vue.prototype.$PerfectScrollbar = PerfectScrollbar;

// Sistema de logging condicional
import logger from './utils/logger';
Vue.prototype.$logger = logger;

Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
locale.use(lang);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: 'history',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Route Guards para protección de rutas
router.beforeEach((to, from, next) => {
  // Lista de rutas públicas que no requieren autenticación
  const publicRoutes = ['/login', '/register', '/lock', '/dailyPassValidator', '/successfull-payment', '/sugerencias-publicas'];
  
  // Rutas de Personal Trainer (sin autenticación durante desarrollo)
  const trainerRoutes = ['/trainer'];
  
  // Funciones auxiliares para validación de sesión
  const isAuthenticated = () => {
    const token = sessionStorage.getItem('jCxbraoQeD');
    const username = sessionStorage.getItem('WHbUjdv3TG');
    const accountType = sessionStorage.getItem('account-type');
    const email = sessionStorage.getItem('email');
    
    // Validación básica de existencia de datos de sesión
    if (!token || !username || !accountType) {
      return false;
    }
    
    // Validar formato del token (debe tener al menos 10 caracteres)
    if (token.length < 10) {
      return false;
    }
    
    // Validar que el tipo de cuenta sea válido
    const validAccountTypes = ['SOPORTE', 'ADMINISTRADOR', 'PERSONAL_TRAINER'];
    if (!validAccountTypes.includes(accountType)) {
      return false;
    }
    
    // Validar que el usuario no sea un string vacío
    if (username.trim() === '') {
      return false;
    }
    
    return true;
  };
  
  const isTokenExpired = () => {
    // Verificar si hay indicadores de token expirado
    const token = sessionStorage.getItem('jCxbraoQeD');
    if (!token) return true;
    
    // Aquí podrías agregar lógica más específica para validar la expiración del token
    // Por ahora, verificamos que el token no esté vacío o sea muy corto
    return token.length < 10;
  };
  
  const isSessionLocked = () => {
    return sessionStorage.getItem('isLocked') === 'true';
  };
  
  const clearSession = () => {
    sessionStorage.clear();
    localStorage.clear();
    // Limpiar cookies relacionadas con la sesión
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
  };
  
  // Verificar si la ruta es pública
  const isPublicRoute = publicRoutes.includes(to.path);
  
  // Verificar si es una ruta de Personal Trainer (acceso libre durante desarrollo)
  const isTrainerRoute = trainerRoutes.some(route => to.path.startsWith(route));
  
  // Verificar si la ruta requiere autenticación (meta.requiresAuth o rutas bajo /admin)
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth) || 
                      to.path.startsWith('/admin') || 
                      to.path.startsWith('/customers') ||
                      to.path.startsWith('/plans') ||
                      to.path.startsWith('/sales') ||
                      to.path.startsWith('/access') ||
                      to.path.startsWith('/registro-cambios') ||
                      to.path.startsWith('/settings') ||
                      to.path.startsWith('/downloads') ||
                      to.path.startsWith('/tools') ||
                      to.path.startsWith('/mail-engine');
  
  // Manejo especial para la ruta raíz
  if (to.path === '/' || to.path === '') {
    if (isAuthenticated() && !isSessionLocked()) {
      next({ path: '/admin/overview' });
    } else if (isSessionLocked()) {
      next({ path: '/lock' });
    } else {
      next({ path: '/login' });
    }
    return;
  }
  
  // Lógica de navegación
  if (isPublicRoute) {
    // Rutas públicas - permitir acceso
    // Si ya está autenticado y va a login, redirigir al dashboard
    if (to.path === '/login' && isAuthenticated() && !isSessionLocked()) {
      next({ path: '/admin/overview' });
    } else if (to.path === '/lock' && !isSessionLocked()) {
      // Si va a lock pero no está bloqueado, redirigir según autenticación
      if (isAuthenticated()) {
        next({ path: '/admin/overview' });
      } else {
        next({ path: '/login' });
      }
    } else {
      next();
    }
  } else if (isTrainerRoute) {
    // Rutas de Personal Trainer - acceso libre durante desarrollo
    console.log('🏋️ Acceso libre a ruta de Personal Trainer (modo desarrollo):', to.path);
    next();
  } else if (requiresAuth) {
    // Rutas protegidas - verificar autenticación
    if (!isAuthenticated() || isTokenExpired()) {
      // No autenticado o token expirado - limpiar sesión y redirigir a login
      clearSession();
      next({ 
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else if (isSessionLocked()) {
      // Autenticado pero sesión bloqueada - redirigir a lock
      next({ 
        path: '/lock',
        query: { redirect: to.fullPath }
      });
    } else {
      // Autenticado y sesión activa - permitir acceso
      next();
    }
  } else {
    // Rutas sin configuración específica - aplicar protección por defecto
    if (isAuthenticated() && !isTokenExpired()) {
      if (isSessionLocked()) {
        next({ path: '/lock', query: { redirect: to.fullPath } });
      } else {
        next();
      }
    } else {
      clearSession();
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }
  
  // Logging para debug (solo en desarrollo)
  if (process.env.NODE_ENV === 'development') {
    console.log('🛣️ Route Guard:', {
      to: to.path,
      from: from.path,
      isPublic: isPublicRoute,
      isTrainer: isTrainerRoute,
      requiresAuth: requiresAuth,
      isAuth: isAuthenticated(),
      isLocked: isSessionLocked(),
      isTokenExpired: isTokenExpired(),
      token: sessionStorage.getItem('jCxbraoQeD') ? 'present' : 'missing',
      username: sessionStorage.getItem('WHbUjdv3TG') || 'missing',
      accountType: sessionStorage.getItem('account-type') || 'missing'
    });
  }
});

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
  components: {}
});

/* 
// FUNCIÓN GLOBAL DE EMERGENCIA COMENTADA - USADA PARA DEBUGGING DEL PROBLEMA DE MODAL PERSISTENTE
// Esta función fue implementada para resolver casos extremos de modales de carga que no desaparecían
// Una vez resuelto el problema, se mantiene comentada para futuras referencias si es necesario

if (typeof window !== 'undefined') {
  window.EMERGENCY_KILL_LOADING = () => {
    // ... código comentado para debugging ...
  }
}
*/
